import { Column } from "@ant-design/plots"
import { Skeleton } from "../../common"

const BarChart = ({ loading, disabled, isStacked, handleBarClick = () => {}, ...config }) => {
  const numberOfBars = config?.data?.length > 0 ? Math.min(config?.data?.length, 4) : 4
  return loading ? (
    <div style={{ padding: 16 }}>
     <div
        style={{
          display: "flex",
          justifyContent: "center",  
          alignItems: "flex-end",
          gap: 16,
          height: 320,
          position: "relative",
          paddingBottom: 16,
          marginLeft: 12,
        }}
      >
        {Array.from({ length: numberOfBars }).map((_, idx) => (
          <Skeleton key={idx} type="button" width={12} height={240 + (idx % 3) * 20} active />
        ))}
      </div>
    </div>
  ) : (
    <Column
      legend={{ position: "bottom" }}
      isStack={isStacked}
      label={false}
      style={disabled ? { pointerEvents: "none", opacity: 0.7 } : undefined}
      onReady={plot => {
        plot.on("element:click", handleBarClick)
      }}
      {...config}
    />
  )
}
export default BarChart
